import { render, staticRenderFns } from "./ToggleArrow.vue?vue&type=template&id=81d4f8b2&"
import script from "./ToggleArrow.vue?vue&type=script&lang=js&"
export * from "./ToggleArrow.vue?vue&type=script&lang=js&"
import style0 from "./ToggleArrow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports